import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { simulationCasePath } from "./constants";
import type { SimulationCase, SimulationItemResponse } from "./types";
import { isSimulationCaseResult } from "./validators";

export const getSimulationCase = reactQueryFetcherAdapter(
  simulationCasePath,
  (signal: AbortSignal, appGroupId: string, id: string): Promise<SimulationItemResponse<SimulationCase>> =>
    fetch(`/${appGroupId}/conversational/simulation/cases/${id}`, "GET", {}, { signal }),
  isSimulationCaseResult
);
